var $ = require('jquery')

var tri = require('tripartite').createBlank()
tri.parseTemplateScript(require('./browser.tmpl'))

var templates = tri.templates

var addStylesIfNeeded = function() {
	if($('#pic-browser-styles').length == 0) {
		$('head').append('<style type="text/css" id="pic-browser-styles">' +
		templates['picBrowserStyles']() +
		'</style>')
	}
}

var PicBrowser = function(/*array*/ pictures, /*function*/ chosenCallback) {
	this.chosenCallback = chosenCallback
	this.renderObjs = []
	for(var i in pictures) {
		var location = pictures[i]
		if(typeof location == 'string') {
			this.renderObjs.push({
				thumbnail: location,
				fullSize: location,
				name: location.split('/').pop()
			})
		}
		else {
			this.renderObjs.push(location)
		}
	}
}

PicBrowser.prototype.render = function(container) {
	addStylesIfNeeded()
	$(container).append(templates['picBrowserHolder']({images: this.renderObjs}))
	
	var self = this
	$(container).on('click', '.pic-holder', function(evt) {
		evt.preventDefault()
		if(self.chosenCallback) {
			self.chosenCallback(self.renderObjs[$(evt.target).closest('.pic-holder').index()])
		}
	})
}

module.exports = PicBrowser